import { CompanyRepository } from "../../domain/repository/company_repository";
import { CompanyApiService } from "../data_source/remote/company_api_service";


export class CompanyRepositoryImpl implements CompanyRepository {
    private companyApiService: CompanyApiService;

    constructor() {
        this.companyApiService = new CompanyApiService();
    }

    async checkCompanyExists(pin: string): Promise<boolean> {
        const response = await this.companyApiService.companyExists(pin);
        if (response.status == 200) {
            return response.data["response"];
        }
        return false;
    }
}